import React, { Component } from 'react';

import { withTranslation } from 'react-i18next'
import Moment from 'react-moment';
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'

class Grunnerverv extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleGrunnerverv = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var grunnerverv = this.props.grunnerverv
        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleGrunnerverv}>
                    <span className="title"><Moment local>{grunnerverv.grunnervervFortDato}</Moment> {grunnerverv.grunnervervReferanse}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('grunnervervreferanse')}</div>
                            <div className="value">{grunnerverv.grunnervervReferanse}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('grunnervervfortdato')}</div>
                            <div className="value"><Moment local>{grunnerverv.grunnervervFortDato}</Moment></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('erverver')}</div>
                            <div className="value">{grunnerverv.erververNavn}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('orgnummer')}</div>
                            <div className="value">{grunnerverv.erververOrganisasjonsnummer}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('adresse')}</div>
                            <div className="value">{grunnerverv.erververForretningsadresselinje2 || grunnerverv.erververForretningsadresselinje1}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('poststed')}</div>
                            <div className="value">{grunnerverv.erververForretningsadresselinje3}</div>
                        </div>
                    </div>

                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Grunnerverv)